(function () {
  'use strict';

  function initAccordion(accordion) {
    accordion.querySelectorAll('[data-faq-item]').forEach(function (item) {
      const btn = item.querySelector('[data-faq-btn]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        accordion.querySelectorAll('[data-faq-item]').forEach(function (other) {
          other.classList.remove('is-open');
          const otherBtn = other.querySelector('[data-faq-btn]');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-faq-accordion]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
